import { supabase } from "@/integrations/supabase/client";

/**
 * Permite que um jogador se torne mentor
 * Atualiza o role no perfil e cria registro em mentor_info se necessário
 */
export async function becomeMentor(userId: string): Promise<{ success: boolean; error?: string }> {
  try {
    console.log(`🔄 [becomeMentor] Iniciando conversão para mentor do usuário: ${userId}`);
    
    // 1. Verificar se já é mentor
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('role')
      .eq('id', userId)
      .single();

    if (profileError) {
      console.error(`❌ [becomeMentor] Erro ao buscar perfil:`, profileError);
      throw profileError;
    }

    if (profile.role === 'mentor') {
      console.warn(`⚠️ [becomeMentor] Usuário já é mentor`);
      return { success: false, error: 'Você já é um mentor!' };
    }

    if (profile.role === 'admin') {
      console.warn(`⚠️ [becomeMentor] Admin não pode se tornar mentor desta forma`);
      return { success: false, error: 'Administradores já têm acesso completo.' };
    }

    // 2. Atualizar role para mentor
    console.log(`📝 [becomeMentor] Atualizando role para mentor...`);
    const { error: roleError } = await supabase
      .from('profiles')
      .update({ role: 'mentor' })
      .eq('id', userId);

    if (roleError) {
      console.error(`❌ [becomeMentor] Erro ao atualizar role:`, roleError);
      throw roleError;
    }

    console.log(`✅ [becomeMentor] Role atualizado com sucesso`);

    // 3. Criar registro em mentor_info se não existir
    console.log(`📝 [becomeMentor] Criando registro em mentor_info...`);
    const { error: mentorError } = await supabase
      .from('mentor_info')
      .upsert({
        profile_id: userId,
        commission_rate: 0.2, // Taxa padrão de 20%
        is_active: true
      }, {
        onConflict: 'profile_id' // Se já existir, atualiza
      });

    if (mentorError && mentorError.code !== '23505') { // Ignorar erro de duplicata
      console.error(`❌ [becomeMentor] Erro ao criar mentor_info:`, mentorError);
      // Não falha a operação se mentor_info já existir ou se houver outro erro não crítico
      // Mas logamos para debug
    } else {
      console.log(`✅ [becomeMentor] Registro em mentor_info criado/atualizado`);
    }

    console.log(`✅ [becomeMentor] Conversão para mentor concluída com sucesso!`);
    return { success: true };
  } catch (error: any) {
    console.error(`❌ [becomeMentor] Erro geral:`, error);
    return { success: false, error: error.message || 'Erro desconhecido ao tornar-se mentor' };
  }
}

